module.exports = __webpack_public_path__ + "static/media/spare.9e3eab86.png";